export const configTypeOptions = [
  { label: '全部', value: '' },
  { label: '集团配置', value: 0 },
  { label: '公司配置', value: 1 },
]

export const stateOptions = [
  { label: '全部', value: '' },
  { label: '启用', value: 1 },
  { label: '停用', value: 0 },
]

export const paginationData = {
  // 分页
  pageNum: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [5, 10, 20, 50],
}

export const columnsCom = function () {
  const columns = [
    {
      name: 'organizationName',
      columnProps: {
        label: '钉钉组织',
        prop: 'organizationName',
      },
    },
    {
      name: 'open',
      columnProps: {
        label: '状态',
        prop: 'open',
      },
      render: ({ row }) => {
        const findItem = this.stateOptions.find((item) => item.value === row.open)
        return this.$createElement(
          'span',
          {},
          (findItem && findItem.label) || '--',
        )
      },
    },
    {
      name: 'modifiedUserName',
      columnProps: {
        label: '更新人',
        prop: 'modifiedUserName',
      },
    },
    {
      name: 'gmtModified',
      columnProps: {
        label: '最后更新时间',
        prop: 'gmtModified',
        width: '180px',
      },
    },
  ]
  return {
    columns,
  }
}
